function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as cmsActions } from '../../reducers/cms.reducer';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import AssetImage from './asset/AssetImage.react';
import AssetOriginal from './asset/AssetOriginal.react';
import AssetMetaData from './asset/AssetMetaData.react';
import AssetUsage from './asset/AssetUsage.react';
import AssetReupload from './asset/AssetReupload.react';
import AssetDescription from './asset/AssetDescription.react';
var Asset = function Asset() {
  var dispatch = useDispatch();
  var navigate = useNavigate();
  var _useParams = useParams(),
    assetID = _useParams.assetID;
  var cmsAssets = useSelector(function (s) {
    return s.cms.assets || {};
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    asset = _useState2[0],
    setAsset = _useState2[1];
  useEffect(function () {
    dispatch({
      type: cmsActions.assets,
      payload: {
        formData: {
          assetID: assetID
        }
      }
    });
  }, []);
  useEffect(function () {
    setAsset(cmsAssets[assetID] || {});
  }, [cmsAssets]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content asset"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--back",
    style: {
      cursor: 'pointer'
    },
    onClick: function onClick() {
      navigate(-1);
    }
  }, "back")), /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Asset :: "
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(AssetImage, asset), /*#__PURE__*/React.createElement(AssetOriginal, asset), /*#__PURE__*/React.createElement(AssetMetaData, asset))), /*#__PURE__*/React.createElement(AssetDescription, asset), /*#__PURE__*/React.createElement(AssetUsage, asset), /*#__PURE__*/React.createElement(AssetReupload, asset)));
};
export default Asset;